module.exports = __webpack_public_path__ + "tc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tc.svg
// module id = 1085
// module chunks = 0